import React from 'react';
import styled from '@emotion/styled';
import {
	FixedGrid,
	FixedGridItem,
	Grid,
	GridItem,
	Gutter,
	IGridItemProps,
	ITheme,
} from '../../../ui';
import themed from '../../../ui/themer/themed';

function getGridStyles() {
	return () => `
		margin-bottom: 24px;
	`;
}

function getGridItemStyles() {
	return themed(
		({ border }) => `
		border: ${border.highlight};
		padding: 10px;
	`,
	);
}

const StyledGrid = styled(Grid)`
	${getGridStyles}
`;

const StyledItem = styled(GridItem)<IGridItemProps, ITheme>`
	${getGridItemStyles}

	p {
		max-width: none;
	}
`;

const StyledFixedGrid = styled(FixedGrid)`
	${getGridStyles}
`;

const StyledFixedGridItem = styled(FixedGridItem)<{}, ITheme>`
	${getGridItemStyles}
`;

const AnotherStyledFixedGridItem = styled(StyledFixedGridItem)`
	border-color: ${themed(({ color }) => color.border.default)};
`;

const StyledFixedGridWithCustomGutter = styled(StyledFixedGrid)`
	${themed((theme) =>
		Gutter.getResponsiveValues(
			theme,
			['100px', { mobileXL: '50px' }],
			'horizontal',
		),
	)}
`;

export const GridItems = () => (
	<>
		<h2 id="grid">Grid</h2>

		<h4>Flexible grid, every item with custom size</h4>

		<StyledGrid>
			<StyledItem columns={[8, { mobileXL: 12 }]}>
				<h2>Hello</h2>
				<p>
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tempore
					placeat cupiditate aut assumenda voluptate? Perspiciatis magni
					corporis soluta quibusdam impedit corrupti mollitia. In maxime nihil
					maiores exercitationem fuga facilis repudiandae!
				</p>
			</StyledItem>
			<StyledItem columns={[4, { mobileXL: 12 }]}>
				<h2>World</h2>
				<p>
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tempore
					placeat cupiditate aut assumenda voluptate? Perspiciatis magni
					corporis soluta quibusdam impedit corrupti mollitia. In maxime nihil
					maiores exercitationem fuga facilis repudiandae!
				</p>
			</StyledItem>
		</StyledGrid>

		<h4>Flexible grid, growing depending on the content</h4>

		<StyledGrid>
			<StyledItem grow columns={[8, { mobileXL: 12 }]}>
				<h2>Hello</h2>
				<p>
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tempore
					placeat cupiditate aut assumenda voluptate? Perspiciatis magni
					corporis soluta quibusdam impedit corrupti mollitia. In maxime nihil
					maiores exercitationem fuga facilis repudiandae!
				</p>
			</StyledItem>
			<StyledItem grow columns={[4, { mobileXL: 12 }]}>
				<h2>World</h2>
				<p>
					Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tempore
					placeat cupiditate aut assumenda voluptate? Perspiciatis magni
					corporis soluta quibusdam impedit corrupti mollitia. In maxime nihil
					maiores exercitationem fuga facilis repudiandae!
				</p>
			</StyledItem>
		</StyledGrid>

		<h4>Fixed grid, every item equally sized</h4>

		<StyledFixedGrid
			itemSelector={[StyledFixedGridItem, AnotherStyledFixedGridItem]}
			columns={[4, { tablet: 2, mobile: 1 }]}
		>
			<StyledFixedGridItem>hello world</StyledFixedGridItem>
			<AnotherStyledFixedGridItem>hello</AnotherStyledFixedGridItem>
			<AnotherStyledFixedGridItem>world</AnotherStyledFixedGridItem>
			<StyledFixedGridItem>hello world</StyledFixedGridItem>
		</StyledFixedGrid>

		<h4>Fixed grid with custom gutter</h4>

		<StyledFixedGridWithCustomGutter
			itemSelector={StyledFixedGridItem}
			columns={[4, { tablet: 2, mobile: 1 }]}
		>
			<StyledFixedGridItem>hello world</StyledFixedGridItem>
			<StyledFixedGridItem>hello</StyledFixedGridItem>
			<StyledFixedGridItem>world</StyledFixedGridItem>
			<StyledFixedGridItem>hello world</StyledFixedGridItem>
		</StyledFixedGridWithCustomGutter>
	</>
);
